import type { FaireProductEntity } from "../../entity_types/product";

export const p_nxgeqkuueg: FaireProductEntity = {
  token: "p_nxgeqkuueg",
  type: "product",
  name: "Core Water 12/43OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/b1685d5b3600ea05a3f279b9043f7aa5c3f854ecdaaf9ba38d055e1245c9f11b.jpeg",
  galleryImageUrls: [],
  priceDollars: 54.04,
  description: "Large format hydration bottle. 12-pack of 43 oz bottles.",
  tags: [],
  msrpDollars: 108.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:04.483Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
